export default {
  'task.title': '任务',

  'task.column.time': '执行时间',
  'task.column.taskId': '任务ID',
  'task.column.type': '任务类型',
  'task.column.status': '执行状态',
  'task.column.count': '执行次数',
  'task.column.action': '操作',

  'task.action.viewTaskData': '查看任务数据',
  'task.action.viewFailureReason': '查看失败原因',
  'task.action.retry': '重试',

  'task.reason.title': '失败原因',
  'task.data.title': '任务数据',
};
